/** @format */
export { v2_pages_notification_notifications_list_constants_select_options_constant__selectOptions as selectOptions } from '../../../../_config/countries';

export const pharmacyOptions = [
	{ label: 'Farmazul', value: 'farmazul' },
	{ label: 'Chispita', value: 'chispita' },
	{ label: 'Los Angeles', value: 'losangeles' },
	{ label: 'Paris', value: 'paris' },
	{ label: 'Farmaplus', value: 'farmaplus' },
	{ label: 'ABC', value: 'abc' },
];
